"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramRow = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _clsx = require("clsx");
var styles = _interopRequireWildcard(require("./ProgramRow.css"));
var _utils = require("@cian/utils");
var _assets = require("../../../../assets");
var _constants = require("../../../../constants");
var _RateCell = require("../../../RateCell");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgramRow = _ref => {
  let {
    id,
    name,
    shortDescription,
    rate,
    showEscrow,
    escrowRate,
    creditLimitMillions,
    termYears,
    payment,
    onProgramClick,
    onLabelClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['row'],
    onClick: onProgramClick
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.clsx)(styles['info-cell'])
  }, /*#__PURE__*/React.createElement("img", {
    className: styles['icon'],
    src: _assets.programIcons[id]
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['info']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['name']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, name)), shortDescription && /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    color: "gray60_100"
  }, shortDescription))), /*#__PURE__*/React.createElement(_RateCell.RateCell, {
    showEscrow: showEscrow,
    escrowRate: escrowRate,
    rate: rate
  }), /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    textAlign: "right"
  }, "\u0434\u043E ", creditLimitMillions, " \u043C\u043B\u043D \u20BD"), /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    textAlign: "right"
  }, "\u0434\u043E ", termYears, " \u043B\u0435\u0442"), /*#__PURE__*/React.createElement("div", {
    className: styles['payment']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    textAlign: "right"
  }, (0, _utils.numberToPrettyString)(payment), " \u20BD/\u043C\u0435\u0441"), /*#__PURE__*/React.createElement("a", {
    className: styles['online-label'],
    href: _constants.MORTGAGE_LINK,
    onClick: onLabelClick,
    target: "_blank",
    rel: "noreferrer"
  }, "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043E\u043D\u043B\u0430\u0439\u043D")));
};
exports.ProgramRow = ProgramRow;